import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

import { ToastService } from '../../services';
import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-container',
  imports: [AsyncPipe, ToastComponent],
  template: `
    <div
      class="toast-container {{ verticalPosition }} {{ horizontalPosition }}"
    >
      @for (
        toast of toastService.toastFeed$ | async;
        track toast;
        let i = $index
      ) {
        <app-toast
          [alertLevel]="toast.alertLevel"
          [heading]="toast.heading"
          [body]="toast.body"
          [timeout]="toast.timeout"
          [animate]="animate"
          [animationSlideDirection]="animationSlideDirection"
          (dismiss)="toastService.popIndex(i)"
        ></app-toast>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  toastService = inject(ToastService);

  @Input() verticalPosition: 'top' | 'bottom';
  @Input() horizontalPosition: 'left' | 'right' | 'center';
  @Input() animate: boolean;
  @Input() animationSlideDirection: 'up' | 'down' | 'right' | 'left';
}
